import { useHistory, useLocation } from "react-router-dom"
import { useAuthDataContext } from "../../../_providers/Auth"

/**
 * Довършва логването (независимо дали е през форма, токен или 2FA код)
 */
function useOnLogin() {
  const auth = useAuthDataContext()
  const history = useHistory()
  const location = useLocation()

  const onLogin = (data) => {
    auth.login(data)

    let searchParams = new URLSearchParams(location.search)
    let redirectUrl = searchParams.get("redirect") || "/"

    // ако е партньор и е управител и не е попълнил нещо от настройките
    // да го пратим на страницата с разяснения
    if (data?.user?.role?.name === "manager") {
      auth.loadNeccesarySettings(false).then((settings) => {
        let redirect = false

        Object.entries(settings).map((e) => {
          if (e[1].required && !e[1].filled) {
            redirect = true
          }
        })

        if (redirect) {
          history.replace("/company?tab=neccesary-settings")
        } else {
          history.replace(redirectUrl)
        }
      })
    } else {
      history.replace(redirectUrl)
    }
  }

  return onLogin
}

export default useOnLogin
